import { useAtomValue } from 'jotai';
import { isLoggedInAtom } from 'app/atoms';
import { useUser } from 'app/network/user';
import { canGuestsUseListingCategories, canUseListingCategories } from 'app/utils/helpers';

export function useListingCategoriesEnabled(): boolean {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const { data: user } = useUser();
  return isLoggedIn ? canUseListingCategories(user?.featureFlags) : canGuestsUseListingCategories();
}
